import { Configuration, PopupRequest } from '@azure/msal-browser';
import { env } from '@/env';

/**
 * Configuration object for MSAL authentication
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: env.VITE_AUTH_CLIENT_ID,
    authority: env.VITE_AUTH_AUTHORITY,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    knownAuthorities: [
      env.VITE_AUTH_AUTHORITY // REQUIRED for CIAM/B2C
    ]
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest: PopupRequest = {
  scopes: [
    `api://${env.VITE_AUTH_CLIENT_ID}/access_as_user`,
  ],
};
